export default __webpack_public_path__ + "static/image2-d37b3c17ba23ad38059a65ed86772942.svg";